import { handleJoiSchemaError } from '../utils';
import { logMediumError } from '../utils/logger';
import {
  API_GET_COMPANY_CHATBOT_LINK,
  API_GET_COMPANY_CONFIGURATION,
  API_GET_COMPANY_LOYALTY,
} from './api';
import { DEFAULT_URL_DOMAIN, sendGetRequest } from './backend';

export const getCompanyLoyalty = async (companyId: string) => {
  try {
    const response = await sendGetRequest(
      API_GET_COMPANY_LOYALTY(companyId),
      null,
      false
    );

    return response.data;
  } catch (error) {
    logMediumError(
      `Could not get company ${companyId} loyalty configuration ${handleJoiSchemaError(
        error
      )}`
    );
    throw error;
  }
};

export const getCompanyChatbotLink = async (companyId: string) => {
  try {
    const response = await sendGetRequest(
      API_GET_COMPANY_CHATBOT_LINK(companyId),
      null,
      false
    );

    return response.data;
  } catch (error) {
    logMediumError(
      `Could not get company ${companyId} chatbot link ${handleJoiSchemaError(
        error
      )}`
    );
    throw error;
  }
};

export const getCompanyWebAppConfiguration = async (companyId: string) => {
  try {
    const response = await sendGetRequest(
      `${DEFAULT_URL_DOMAIN}${API_GET_COMPANY_CONFIGURATION(companyId)}`,
      null,
      false
    );

    return response.data;
  } catch (error) {
    logMediumError(
      `Could not get company ${companyId} webapp configuration ${handleJoiSchemaError(
        error
      )}`
    );
    throw error;
  }
};
